module.exports = __webpack_public_path__ + "static/media/night.2274b95f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gifs/night.gif
// module id = 848
// module chunks = 0